export const paperUsesHindiTranslations = (paper: any): boolean => {
  const haystack = [paper?.name, paper?.paper_template?.name, paper?.paper_request?.name].filter(Boolean).join(' ')
  return /hindi/i.test(haystack)
}

/** Languages are stored with mixed casing ("english", "English", "ENGLISH"), so compare case-insensitively. */
export const sameLanguage = (a: any, b: any): boolean =>
  String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase()

export const resolveSubsectionLangs =(subSection: any, paper?: any) => {
  const base_lang = subSection?.base_lang || ''
  const target_lang = subSection?.target_lang || (!base_lang && paperUsesHindiTranslations(paper) ? 'hindi' : '')
  return {
    base_lang,
    target_lang,
    isExpectingBilingual: !!(base_lang && target_lang),
    isTransilation: !!(!base_lang && target_lang),
    isBaseLanguage: !!(base_lang && !target_lang),
  }
}
